import { render, staticRenderFns } from "./MyRelationsMap.vue?vue&type=template&id=e6153770&scoped=true"
import script from "./MyRelationsMap.vue?vue&type=script&lang=ts"
export * from "./MyRelationsMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6153770",
  null
  
)

export default component.exports